import ServiceDetailBook from "./ServiceDetailBook";
import ServiceDetailFind from "./ServiceDetailFind";
import ServiceDetailGallery from "./ServiceDetailGallery";
import ServiceDetailHead from "./ServiceDetailHead";
import ServiceDetailPerform from "./ServiceDetailPerform";
import ServiceDetailRange from "./ServiceDetailRange";
import ServiceDetailSlide from "../ServiceDetail/ServiceDetailSlide";
import ServiceDetailStyle from "./ServiceDetailStyle";

export default function ServiceDetail() {

  const imgSlide = [
      { 
        title: 'Style & mood',
        name: 'Premium Veneers',
        para: 'Natural veneers in rich tones and grains add warmth and timeless appeal to interiors.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/millwork-split-1.webp',
        imageB: '../image/millwork-split-1b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Solid Timber Elements',
        para: 'Handcrafted details in premium woods, built for structural integrity and enduring beauty.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/millwork-split-2.webp',
        imageB: '../image/millwork-split-2b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Glass / Mirror Wall Paneling',
        para: 'Elegant glass and mirror wall paneling that adds depth and modern sophistication.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/millwork-split-3.webp',
        imageB: '../image/millwork-split-3b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Stone Sophistication',
        para: 'A timeless touch that adds depth, warmth, and character to your interiors.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/millwork-split-4.webp',
        imageB: '../image/millwork-split-4b.webp',
      },

      { 
        title: 'Style & mood',
        name: 'Metallic Harmony',
        para: 'A fusion of texture and shine, bringing depth and sophistication to walls.',
        link: '/project',
        linktext: 'Explore The Collections',
        imageA: '../image/millwork-split-5.webp',
        imageB: '../image/millwork-split-5b.webp',
      },
    ]
    
  return (
    <>
    <ServiceDetailHead/>
    <ServiceDetailFind/>
    <ServiceDetailRange/>
    <ServiceDetailGallery/>
    <ServiceDetailStyle/>
    <ServiceDetailSlide imgSlide={imgSlide}/>
    <ServiceDetailBook/>
    <ServiceDetailPerform/>
    </>
  )
}
